/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EvaluationResultSchema } from './evaluationResultSchema';
import type { EvaluationRowSchemaProfileCard } from './evaluationRowSchemaProfileCard';
import type { EvaluationRowSchemaScoreBand } from './evaluationRowSchemaScoreBand';
import type { EvaluationRowSchemaStatus } from './evaluationRowSchemaStatus';

/**
 * One row in the arbitrator results table — mirrors the Figma.
 */
export interface EvaluationRowSchema {
  profile_id: string;
  job_candidate_id?: string | null;
  status: EvaluationRowSchemaStatus;
  overall_score?: number | null;
  score_band?: EvaluationRowSchemaScoreBand;
  rank_position?: number | null;
  profile_card: EvaluationRowSchemaProfileCard;
  results: EvaluationResultSchema[];
}
